export function getValueWithConfig<T>(userValue: T | undefined, configValue: T | undefined, defaultValue: T): T | undefined {
  return typeof userValue === "undefined" ? (typeof configValue === "undefined" ? defaultValue : configValue) : userValue;
}
